

define(['angular', 'squid/index', 'text!./template.html', '../lib/util', 'components/xo-page-components/src/value-props/directive', 'components/xo-form-components/src/phone/phoneInput/directive', 'components/xo-form-components/src/name-input/directive', 'guest/emailInput/directive', 'guest/passwordInput/directive', 'guest/countryList/directive', 'guest/sepa/directive', // TODO: Check if its used
'guest/select-shipping-method/directive', 'components/xo-models/src/onboard/index', 'login-button/directive', 'components/xo-locale/dist/index', 'components/xo-locale/dist/helper', 'components/xo-models/src/address/index', 'components/xo-models/src/checkout/index', 'components/xo-models/src/shippingMethod/index', 'components/xo-ui-components/src/ui-utils/directive', 'components/xo-ui-components/src/accessibility/directive'], function (angular, module, template, util) {
    return angular.module('xo-multistep-signup-add-card.directive', ['squid', 'xo-value-props.directive', 'xo-phone.phoneInput', 'xo-name-input.directive', 'xo-guest.emailInput', 'xo-guest.passwordInput', 'xo-guest.countryList', 'xo-onboard.sepa.directive', // TODO: Check if its used
    'xo-guest-select-shipping-method.directive', 'xomodel.onboard', 'xo-login-button.directive', 'locale.helper', 'xomodel.address', 'xomodel.checkout', 'xo-ui-utils.directive', 'xo-accessibility.directive']).directive('formErrorDetect', function () {

        return function ($scope, el, attrs) {
            $scope.$watch(attrs.name + '.$error', function (newVal, oldVal) {
                var cardModel = $scope.multistepSignupModel.onboard.card;

                /*
                 * Here we are making sure that both luhn and len validation
                 * together marks the cardModel validity which in-tern handles
                 * form submit and validity in front-end
                 * Background:
                 * card input element has luhn and len validation as part of
                 * ui-validate util
                 */
                if (newVal.luhn && newVal.luhn[0].$invalid || newVal.len && newVal.len[0].$invalid) {
                    cardModel.valid = false;
                } else {
                    cardModel.valid = true;
                }
            }, true);
        };
    }).directive('xoMultistepSignupAddCard', function () {

        return {
            template: template,

            scope: {
                token: '=',
                parentCallbacks: '=',
                multistepSignupModel: '=',
                positionToErrorField: '=',
                backState: '=',
                backendError: '=',
                clearBackendError: '=',
                normalizeAddress: '=',
                prefillAddressCommon: '=',
                buttonParams: '='
            },

            link: function link($scope) {

                $scope.$watch(function () {
                    return $scope.multistepSignupModel.onboard.card.number;
                }, function cardNumberChangeHandler(newValue, oldValue) {
                    // Sanitize the values
                    newValue = newValue ? newValue.replace(/ /g, '').toLowerCase() : null;
                    oldValue = oldValue ? oldValue.replace(/ /g, '').toLowerCase() : null;

                    if (newValue) {
                        if (newValue !== oldValue) {
                            if ($scope.multistepSignupModel.selectedInstallmentData && !$scope.multistepSignupModel.selectedInstallmentData.preventChange) {
                                // Resetting selected installment data, if installment change is not explicitly prohibited.
                                $scope.multistepSignupModel.selectedInstallmentData = undefined;
                            }
                        }
                    }
                });

                $scope.$watch(function () {
                    return $scope.multistepSignupModel.onboard.card.type;
                }, function cardTypeChangeHandler(newValue, oldValue) {
                    // Sanitize the values
                    newValue = newValue ? newValue.replace(/ /g, '').toLowerCase() : null;

                    var eligibilityModel = $scope.multistepSignupModel.eligibilityModel;
                    var cardNetwork;

                    if (newValue && eligibilityModel && eligibilityModel.installments && eligibilityModel.installments.length > 0) {

                        eligibilityModel.installments.some(function cardCheck(card, index, array) {
                            if (card.cardInfo && card.cardInfo.card_type && card.cardInfo.card_type.toLowerCase() === newValue) {
                                // Card Network Found
                                cardNetwork = card;
                                return true;
                            }
                        });

                        if (cardNetwork && cardNetwork.installment_options && cardNetwork.installment_options.length > 0) {
                            // Card network && installments found
                            if (cardNetwork.installment_options.length === 1) {
                                $scope.multistepSignupModel.selectedInstallmentData = {
                                    installment_option_selected: cardNetwork.installment_options[0],
                                    preventChange: true
                                };
                            }

                            $scope.multistepSignupModel.allowInstallments = true;
                        } else {
                            // Card network does not exists Or No installment found
                            $scope.multistepSignupModel.allowInstallments = false;
                        }
                    } else {
                        $scope.multistepSignupModel.allowInstallments = false;
                    }
                });

                $scope.$on('$destroy', function () {
                    $scope.clearBackendError('multistepsignupaddcard');
                });

                if ($scope.backendError) {
                    $scope.backendError('multistepsignupaddcard');
                }
            },

            controller: function controller($scope, $rootScope, $populate, $state, $util, $locale, $feature, $q, $CheckoutAppDataModel, $ShippingRuleSummaryModel, $CheckoutPayeeModel, $CheckoutCartModel, $BillingAddressModel, $ShippingAddressModel, $PrefillAddressModel, $pxpFactors, $config, $dispatch, $localeHelper, $location, $meta) {

                $scope.locale = $locale;
                $scope.formattedValues = {};
                $scope.backUri = 'checkout.multistepsignup.multistepsignupaddcard';
                $scope.normalize = $feature('addressNormalization', false, $locale.country);
                $scope.componentsFlag = util.componentsMap($locale.country);

                $scope.onCurrencyConversionDone = function () {
                    $state.go($scope.backUri);
                };

                $scope.$on('localeChange', function () {
                    $scope.componentsFlag = util.componentsMap($locale.country);
                    $scope.multistepSignupModel.onboard.billing_address.country = $locale.country;
                    $scope.multistepSignupModel.onboard.shipping_address.country = $locale.country;
                });

                $scope.zipMasking = function (newValue) {
                    $scope.formattedValues.postalCode = util.maskingUtil.maskZip(newValue);
                    $scope.multistepSignupModel.onboard.billing_address.postal_code = $scope.formattedValues.postalCode.replace(/[^0-9]/gi, '');
                };

                function checkShippingRulesExist() {
                    if ($scope.multistepSignupModel.wps_flow && $scope.multistepSignupModel.snt_supported_flow) {
                        return $populate($scope, {
                            shippingRulesSummary: $ShippingRuleSummaryModel.instance($rootScope.token).retrieve({
                                params: {
                                    merchant_id: $scope.payee.merchant.id,
                                    currency_code: $scope.checkoutCart.purchase.amounts.total.currency_code
                                }
                            })
                        }).then(function () {
                            if ($scope.shippingRulesSummary.isSnTEnabled) {
                                $scope.multistepSignupModel.merchant_has_snt_profile = true;
                            }
                        });
                    } else {
                        return $q.when();
                    }
                }

                $scope.isInstallmentsVisible = function isInstallmentsVisible() {
                    var model = $scope.multistepSignupModel;
                    var hasConditionMet = model.allowInstallments && model.onboard.card.number && model.onboard.card.valid;
                    var isBilling = $scope.checkoutCart.isBilling();

                    return !isBilling && hasConditionMet;
                };

                if ($scope.multistepSignupModel.onboard.ue_billing_address) {
                    $scope.multistepSignupModel.onboard.billing_address = $scope.multistepSignupModel.onboard.ue_billing_address;
                    $scope.zipMasking($scope.multistepSignupModel.onboard.ue_billing_address.postal_code);
                }

                if ($locale.country === 'BR' && $scope.multistepSignupModel.onboard.billing_address) {
                    $scope.multistepSignupModel.onboard.billing_address.postal_code = util.maskingUtil.maskZip($scope.multistepSignupModel.onboard.billing_address.postal_code);
                }

                $populate($scope, {
                    checkoutAppData: $CheckoutAppDataModel.instance($scope.token),
                    payee: $CheckoutPayeeModel.instance($scope.token),
                    checkoutCart: $CheckoutCartModel.instance($scope.token)
                }).then(function () {
                    $scope.multistepSignupModel.flags.allowEditShipping = $scope.checkoutAppData.get('flags.allow_change_shipping', false);

                    $scope.multistepSignupModel.installmentDisabled = $scope.checkoutCart.isBilling();

                    $scope.multistepSignupModel.wps_flow = $scope.checkoutAppData.is_wps_flow();
                    $scope.multistepSignupModel.snt_supported_flow = $scope.checkoutAppData.is_snt_supported();

                    $scope.showShippingAddress = Boolean(!$scope.checkoutAppData.flags.hide_shipping_address && $scope.checkoutAppData.flags.shipping_address_required);

                    checkShippingRulesExist();

                    $scope.prefill = function () {
                        var postal_code = $scope.multistepSignupModel.onboard.billing_address.postal_code;

                        $scope.prefillAddressCommon(postal_code, $scope.multistepSignupModel.onboard.billing_address, $scope.multistepSignupModel.onboard.user, $scope.multistepSignupModel.flags.billingAddress, false);
                    };

                    // Get merchant passed shipping address from either purchase plan or billing agreement plan
                    var merchantSuppliedAddress = $scope.checkoutCart.get('purchase.shipping_address') || $scope.checkoutCart.get('billing.shipping_address');
                    var merchantSuppliedNumber = $scope.checkoutCart.get('purchase.phone_fields') || $scope.checkoutCart.get('billing.phone_fields');

                    if (merchantSuppliedAddress && !$scope.multistepSignupModel.onboard.ue_billing_address) {
                        $scope.multistepSignupModel.onboard.billing_address = $BillingAddressModel.create($scope.token, {
                            country: $locale.country
                        }, merchantSuppliedAddress);

                        $scope.prefill();

                        $scope.zipMasking($scope.multistepSignupModel.onboard.billing_address.postal_code);

                        $scope.multistepSignupModel.onboard.billing_address.postal_code = $scope.formattedValues.postalCode;
                        $scope.multistepSignupModel.onboard.user.first_name = merchantSuppliedAddress.first_name;
                        $scope.multistepSignupModel.onboard.user.last_name = merchantSuppliedAddress.last_name;
                    }

                    if (merchantSuppliedNumber && merchantSuppliedNumber.telephone_country === $locale.country) {
                        $scope.multistepSignupModel.onboard.phone.telephone = merchantSuppliedNumber.normalized_phone_number;
                    }
                });

                var basl_hermes_xoon_redirect = $util.param('hermesXoonRedirect') || $meta.query && $meta.query.hermesXoonRedirect;
                var basl_abtest_throttle = $util.param('abTestThrottle') || $meta.query && $meta.query.abTestThrottle;

                $scope.showLogin = basl_hermes_xoon_redirect || basl_abtest_throttle;

                $scope.redirect = function () {
                    $dispatch('hermes', {
                        hermesLoginRedirect: 'xoon',
                        token: $scope.token,
                        'locale.x': $locale.lang + '_' + $locale.country,
                        'country.x': $locale.country
                    });
                };

                $scope.uponNormalization = function (normalizedAddress, isBack) {
                    if (isBack) {
                        $location.path('/checkout/multistepsignup/multistepsignupaddcard').replace();
                    } else {
                        $scope.normalize = false;
                        $scope.multistepSignupModel.onboard.billing_address.setProperties(normalizedAddress);

                        if ($scope.multistepSignupModel.flags.shipToBilling) {
                            $location.path('/checkout/multistepsignup/multistepsignupcreateaccount').replace();
                        } else {
                            $location.path('/checkout/multistepsignup/multistepsignupaddshipping').replace();
                        }
                    }
                };

                $scope.changeCountry = function changeCountry() {
                    if ($scope.multistepSignupModel.onboard.shipping_address.country && $scope.multistepSignupModel.onboard.shipping_address.country !== $locale.country) {
                        $scope.multistepSignupModel.onboard.shippingCountryChanged = true;
                        $rootScope.$broadcast('countryChange', $scope.multistepSignupModel.onboard.shipping_address.country);
                    } else {
                        $scope.multistepSignupModel.onboard.shippingCountryChanged = false;
                    }
                };

                $scope.onSubmit = function onSubmit() {
                    // Backup user entered address
                    $scope.multistepSignupModel.onboard.ue_billing_address = $BillingAddressModel.create($scope.token, {
                        country: $locale.country
                    }, $scope.multistepSignupModel.onboard.billing_address);

                    if ($scope.componentsFlag.shippingAddress) {
                        $scope.multistepSignupModel.onboard.ue_shipping_address = $ShippingAddressModel.create($scope.token, {
                            country: $locale.country
                        }, $scope.multistepSignupModel.onboard.shipping_address);
                    }

                    // Remove phone formatting
                    $scope.multistepSignupModel.onboard.phone.telephone = $scope.multistepSignupModel.onboard.phone.telephone.replace(/[^0-9]/gi, '');

                    if ($scope.normalize) {
                        $scope.clearBackendError('multistepsignupaddcard');
                        $scope.normalizeAddress($scope.multistepSignupModel.onboard.billing_address, $scope.uponNormalization);
                    } else if ($scope.componentsFlag.shippingAddressPage) {
                        if (!$scope.multistepSignupModel.flags.shipToBilling) {
                            $state.go('checkout.multistepsignup.multistepsignupaddshipping');
                        }
                    } else {
                        $state.go('checkout.multistepsignup.multistepsignupcreateaccount');
                    }
                };
            }
        };
    });
});


//////////////////
// WEBPACK FOOTER
// ./components/xo-guest-components/src/multistep-signup/addCard/directive.js
// module id = ./components/xo-guest-components/src/multistep-signup/addCard/directive.js
// module chunks = 1